<script lang="ts">
  import type { ApiField } from '../../data-tables-api';
  import { toDateValue } from '../format';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  const dateValue = $derived(toDateValue(value));

  function handle(raw: string) {
    if (raw === '') {
      onChange(null);
      return;
    }
    onChange(raw); // YYYY-MM-DD
  }
</script>

<input
  type="date"
  value={dateValue}
  oninput={(e) => handle((e.target as HTMLInputElement).value)}
  required={field.required}
  {disabled}
  class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-pu)] {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
/>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
